import { CancelablePromise, OpenAPI, request as __request } from '/src/api';
import type { TGetLenderStatementHeadlinesRequest, TGetLenderStatementHeadlinesResponse } from '/src/lib/types';

export class LenderStatementHeadlinesService {
  /**
   * Get Lender Statement Headlines
   * @returns Headline
   * @throws ApiError
   */
  public static async get(
    req: TGetLenderStatementHeadlinesRequest
  ): CancelablePromise<TGetLenderStatementHeadlinesResponse> {
    return await __request(OpenAPI, {
      method: 'GET',
      url: '/reports/lender-statement-headlines',
      query: req,
    });
  }
}
